/**
 * ParticularOrderService
 * Auto-generated pattern for ParticularOrder endpoints
 */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParticularOrderStatusUpdateDto } from '../model/particularOrderStatusUpdateDto';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable({ providedIn: 'root' })
export class ParticularOrderService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  public apiParticularOrderUpdateStatusPost(
    body: ParticularOrderStatusUpdateDto,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    if (!body) {
      throw new Error('Body is required');
    }
    const url = `${this.basePath}/api/ParticularOrder/UpdateOrderStatus`;
    return this.httpClient.put<boolean>(url, body, {
      observe,
      reportProgress,
    });
  }
}
